import { useCallback } from "react";
import InsuranceCategory from "../../types/insuranceCategory";

/**
 * Custom hook for handling redirection to Quick Quote pages based on insurance categories.
 *
 * @returns An object containing the goToQuickQuote function
 * @property {Function} goToQuickQuote - A memoized function that redirects to the appropriate insurance quote page
 * @example
 * ```js
 * const { goToQuickQuote } = useQuickQuoteRedirect();
 * // Redirect to car insurance quote page
 * goToQuickQuote(InsuranceCategory.car);
 * ```
 *
 * If an invalid category is provided, it redirects to the base URL and logs an error.
 */
const useQuickQuoteRedirect = () => {
  const goToQuickQuote = useCallback((insuranceCategory) => {
    console.log("insuranceCategory", insuranceCategory);
    const baseUrl = window.location.origin;
    console.log("baseUrl", baseUrl);

    let redirectUrl = "";

    switch (insuranceCategory) {
      case InsuranceCategory.car:
        redirectUrl = `${baseUrl}/customer/motor-insurance/4wheeler/`;
        break;
      case InsuranceCategory.bike:
        redirectUrl = `${baseUrl}/customer/motor-insurance/2wheeler/`;
        break;
      case InsuranceCategory.gcv:
        redirectUrl = `${baseUrl}/customer/motor-insurance/gcv/`;
        break;
      case InsuranceCategory.pcv:
        redirectUrl = `${baseUrl}/customer/motor-insurance/pcv/`;
        break;
      case InsuranceCategory.health:
        redirectUrl = `${baseUrl}/customer/health-insurance/`;
        break;
      case InsuranceCategory.pet:
        redirectUrl = `${baseUrl}/customer/pet-insurance/`;
        break;
      case InsuranceCategory.life:
        redirectUrl = `${baseUrl}/customer/life-insurance?source=Life+Insurance`;
        break;
      default:
        redirectUrl = `${baseUrl}`;
        console.error("Invalid insurance category");
        return;
    }

    // window.location.href = redirectUrl;
    window.open(redirectUrl, "_blank");
  }, []);

  return { goToQuickQuote };
};

export default useQuickQuoteRedirect;
